export default class IscrizioneNewsletter{
    Username;
    CodiceCliente;   
    EmailIscrizione;
    DataRichiestaIscrizione;
    PrivacyPolicy;

    constructor(){}

}